"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Messages = require("../../codegen/Messages");
var index_1 = require("../../index");
var Spinner_1 = require("../../pure-components/Spinner");
/**
 * OUI form dialog component.
 *
 * @oui-component FormDialog
 */
var FormDialogInternal = /** @class */ (function (_super) {
    __extends(FormDialogInternal, _super);
    function FormDialogInternal(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = _this.getInitState();
        _this.formRef = _this.formRef.bind(_this);
        _this.submitForm = _this.submitForm.bind(_this);
        _this.onFormChange = _this.onFormChange.bind(_this);
        _this.onFormValidationFail = _this.onFormValidationFail.bind(_this);
        _this.onFormPostSubmit = _this.onFormPostSubmit.bind(_this);
        _this.onFormPreSubmit = _this.onFormPreSubmit.bind(_this);
        return _this;
    }
    /**
     * Get the initial configuration of the state.
     *
     * @returns A default state object.
     */
    FormDialogInternal.prototype.getInitState = function () {
        return {
            isValid: true,
            isSubmitting: false,
            catchValidationChange: false
        };
    };
    /**
     * Handle the submit form event and call the form's submitForm function.
     *
     * @param event - The click event of the button.
     */
    FormDialogInternal.prototype.submitForm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                event && event.preventDefault();
                // call submit on the form element.
                this.form.submitForm();
                return [2 /*return*/];
            });
        });
    };
    /**
     * Catch the validation fail event from the form. This handles disabling the button through isValid. Additionally
     * call onValidationFail in params if passed to FormModal.
     *
     * @param instance - The form instance object.
     */
    FormDialogInternal.prototype.onFormValidationFail = function (instance) {
        var newState = __assign({}, this.state, { isValid: false, catchValidationChange: true });
        this.setState(newState);
        // Handle pass through since we override it.
        if (this.props.onValidationFail) {
            this.props.onValidationFail(instance);
        }
    };
    /**
     * Catch the form change event from the form. This handles enabling the button again through isValid. Additionally
     * call onChange in params if passed to FormModal.
     *
     * @param instance - The form instance object.
     */
    FormDialogInternal.prototype.onFormChange = function (instance) {
        // onChange fires when displaying the form errors so this catches that error allowing the submit button to stay
        // disabled until the user makes a meaningful change.
        if (this.state.catchValidationChange) {
            this.setState(__assign({}, this.state, { catchValidationChange: false }));
        }
        else {
            this.setState(__assign({}, this.state, { isValid: true }));
        }
        // Handle pass through since we override it.
        if (this.props.onChange) {
            this.props.onChange(instance);
        }
    };
    /**
     * Catch the form pre submit event from the form. This handles disabling the button and showing the spinner by
     * setting isSubmitting. Additionally call preSubmit in params if passed to FormModal.
     *
     * @param instance - The form instance object.
     */
    FormDialogInternal.prototype.onFormPreSubmit = function (instance) {
        return __awaiter(this, void 0, void 0, function () {
            var newState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newState = __assign({}, this.state, { isSubmitting: true, catchValidationChange: true });
                        this.setState(newState);
                        if (!this.props.preSubmit) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.preSubmit(instance)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Catch the form post submit event from the form. This handles hiding the spinner through isSubmitting. Additionally
     * call postSubmit in params if passed to FormModal.
     *
     * @param instance - The form instance object.
     */
    FormDialogInternal.prototype.onFormPostSubmit = function (instance) {
        return __awaiter(this, void 0, void 0, function () {
            var newState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newState = __assign({}, this.state, { isSubmitting: false });
                        this.setState(newState);
                        if (!this.props.postSubmit) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.postSubmit(instance)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get the FormRef object from within the form so we can use it to call submit. Additionally call formRef in params
     * if passed to FormModal.
     *
     * @param instance - The form instance object.
     */
    FormDialogInternal.prototype.formRef = function (form) {
        this.form = form;
        // Handle pass through since we override it.
        if (this.props.formRef) {
            this.props.formRef(form);
        }
        return form;
    };
    /**
     * Render the component.
     */
    FormDialogInternal.prototype.render = function () {
        var _a = this.props, testId = _a.testId, coreProps = __rest(_a, ["testId"]);
        var formProps = __assign({}, coreProps, { formRef: this.formRef, onValidationFail: this.onFormValidationFail, onChange: this.onFormChange, preSubmit: this.onFormPreSubmit, postSubmit: this.onFormPostSubmit });
        var _b = this.state, isSubmitting = _b.isSubmitting, isValid = _b.isValid;
        var footerControls = (React.createElement("div", { className: "oui-form-dialog__footer-controls" },
            React.createElement(index_1.Button, { type: index_1.ButtonType.Submit, buttonStyle: this.props.submitStyle || index_1.ButtonStyle.Primary, disabled: isSubmitting || !isValid, onClick: this.submitForm }, this.props.submitText || Messages.Common.submit()),
            this.props.showCancel && (React.createElement(index_1.Button, { onClick: this.props.closeHandler, disabled: isSubmitting }, Messages.Common.cancel()))));
        // Update the modal props to include our custom footer controls.
        var modalProps = __assign({}, coreProps, { testId: testId, closeDisabled: isSubmitting, footerContent: footerControls, closeLinkText: this.props.closeLinkText || Messages.Common.cancel() });
        return (React.createElement(index_1.Modal, __assign({}, modalProps),
            React.createElement("div", { className: "oui-form-dialog" },
                isSubmitting && React.createElement(Overlay, { overlayText: this.props.overlayText }),
                React.createElement(index_1.Form, __assign({}, formProps), this.props.children))));
    };
    return FormDialogInternal;
}(React.Component));
/**
 * Renders the modal overlay to show the HgDS spinner and loading text while the
 * modal is submitting.
 */
var Overlay = function (props) { return (React.createElement("div", { className: "oui-overlay-default oui-position-cover oui-position-z-index" },
    React.createElement("div", { className: "oui-position-center oui-flex oui-flex-center" },
        React.createElement(Spinner_1.default, { additionalClassNames: [
                "oui-display-block oui-align-center oui-margin-small-bottom"
            ] }),
        React.createElement("span", null, props.overlayText || Messages.Common.loading())))); };
var FormDialog = function (props) { return React.createElement(FormDialogInternal, __assign({}, props)); };
exports.default = FormDialog;
//# sourceMappingURL=FormDialog.js.map